<template>
    <div class="content-wrap calendar">
        <kapp-header id="mainHeader" ref="header"></kapp-header>
        <!--<kapp-categories :categories="categories"></kapp-categories>-->

        <div class="calendar-list">
            <kapp-month v-for="month in showMonths" :id="'month-' + month" v-bind:key="month" :month="month"
                        :events="filteredEvents"></kapp-month>
        </div>
        <kapp-eventslist :events="filteredEvents" ref="eventsList"></kapp-eventslist>
        <overlay />
    </div>
</template>

<script>
	import KappKalenderMonth from "../components/blocks/KappKalenderMonth";
	import api, { ApiDefaults } from "../utils/api_call";
	import KappEventsList from "../components/blocks/KappEventsList";
	import KappCategoryNav from "../components/subparts/KappCategoryNav";
	import Overlay from "../components/subparts/Overlay";
	import Header from "../components/layouts/Header";
	import debounce from "lodash.debounce";

	export default {
		name: "KappKalender",
		components: {
			'kapp-month': KappKalenderMonth,
			'kapp-eventslist': KappEventsList,
			'kapp-categories': KappCategoryNav,
			'kapp-header': Header,
			'overlay': Overlay
		},
		data() {
			return {
				pageTitle: 'Kalender',
				events: [],
				categories: [],
				visibleMonths: 9,
				isLoading: true,
				categoryFilter: '',
				fullTextFilter: ''
			};
		},
		methods: {
			fetchData: debounce(function () {

				let apiParams = Object.assign({}, ApiDefaults, {params: {id: 13}});

				api(apiParams)
					.then(( response ) => {

						if ( response.status === 200  ) {
							if ( response.data.hasOwnProperty('news') ) {
								let events = response.data.news.content;

								events.map(function ( evt ) {
									let usedCategory = this[ evt.categories ];

									evt.color = false; // set Default value
									if ( usedCategory.hasOwnProperty('color') ) {
										evt.color = usedCategory.color;
									}

									return evt;
								}, response.data.news.categories);

								this.events = events;
								this.categories = response.data.news.categories;
								Events.$emit('showCategories', this.categories);

							}
						}
					})
					.catch(( err ) => {
						console.warn(err.message);
					})
					.finally(() => {

						this.isLoading = false;
					});
			}, 125)
		},
		computed: {
			filteredEvents: function () {
				let events = this.events.filter(evt => {
					let category = this.categoryFilter,
						textFilter = this.fullTextFilter,
						inCategory = true;

					if ( textFilter.length < 3 && this.$refs.header._data.showSearch ) return false;

					if ( category ) {
						category = category.split("-");
						inCategory = (evt.categories === category[ 1 ]);
					}

					return inCategory && evt.title.toLowerCase().includes(textFilter.toLowerCase());
				});

				return events;

			},
			startMonth: function () {
				let d = new Date();
				return (d.getMonth());// Januar = 0, also wird durh weitere scripte der eine vorhaerige Monat mit angezeigt

			},
			showMonths: function () {
				return Array(this.visibleMonths).fill(this.startMonth).map(( x, y ) => x + y);
			}
		},
		created() {

			this.fetchData();
			Events.$on('closeSearch', () => this.fullTextFilter = '');
			Events.$on('fullTextSearch', ( val ) => this.fullTextFilter = val);
			Events.$on('switchContentCategory', ( val ) => this.categoryFilter = val);
		},
		updated() {

		},
		watch: {
			filteredEvents( events ) {

				if ( this.fullTextFilter.length > 2 ) {
					Events.$emit('results:found', true);
				}
				else if ( this.fullTextFilter.length > 0 && this.fullTextFilter.length <= 2 ) {
					this.$refs.eventsList._data.isVisible = false;
				}

			},
			'showMonths': function () {
				// this.$nextTick ( function() {
				this.$scrollTo('.month.is-actual', 10, {container: '.content-wrap', offset: -145, duration: 0});
				// });
			}
		}
	};
</script>

<style scoped>


</style>



// WEBPACK FOOTER //
// src/pages/KappKalender.vue